<div>
  <div class="incident-comment-item d-flex align-items-start gap-1" :class="depth ? 'is-reply' : 'ms-2'">
    <div class="incident-comment-avatar rounded-circle overflow-hidden flex-shrink-0">
      <img v-if="controller.get_comment_profile_image(comment)" class="rounded-circle w-100 h-100 object-fit-cover"
        :src="controller.get_comment_profile_image(comment)" :alt="controller.get_comment_author(comment)">
      <span v-else>{{ controller.get_comment_initials(comment) }}</span>
    </div>
    <div class="flex-grow-1 min-vw-0">
      <div class="incident-comment-bubble position-relative bg-white border rounded-3 me-3 px-2 py-1">
        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-1 gap-sm-2 incident-comment-header">
          <div class="d-flex align-items-center gap-1 min-vw-0 text-xxs">
            <span class="fw-bold text-nowrap">{{ controller.get_comment_author(comment) }}</span>
            <template v-if="parent_comment">
              <i class="bi bi-caret-right-fill text-muted" aria-hidden="true"></i>
              <span class="text-muted text-truncate">{{ controller.get_comment_author(parent_comment) }}</span>
            </template>
          </div>
          <div v-if="controller.get_comment_timestamp(comment)" class="text-muted incident-comment-time">
            {{ controller.get_comment_timestamp(comment) }}
          </div>
          <div v-if="controller.can_manage_comment(comment)" class="dropdown flex-shrink-0 ms-auto">
            <button type="button" class="btn btn-link btn-sm text-muted incident-comment-menu-btn"
              data-bs-toggle="dropdown" aria-expanded="false" aria-label="Comment actions"
              :disabled="controller.is_comment_action_loading(comment.id)" @click.stop>
              <i class="bi bi-three-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow-sm incident-comment-menu" @click.stop>
              <li v-if="!controller.is_comment_editing(comment)">
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 text-xs"
                  @click.stop="controller.start_edit_incident_comment(comment)">Edit</button>
              </li>
              <li>
                <button type="button" class="dropdown-item d-flex align-items-center gap-2 text-danger text-xs"
                  @click.stop="controller.delete_incident_comment(report, comment)">Delete</button>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="controller.is_comment_editing(comment)" class="d-flex align-items-center gap-1 mt-1">
          <input class="form-control form-control-sm rounded-pill incident-comment-input" type="text"
            :value="controller.editing_comment_drafts[comment.id]"
            @input="controller.editing_comment_drafts[comment.id] = $event.target.value"
            @keyup.enter="controller.submit_edit_incident_comment(report, comment)"
            @keyup.esc="controller.cancel_edit_incident_comment">
          <button type="button" class="btn btn-sm btn-primary rounded-circle incident-send-btn"
            :disabled="controller.is_comment_action_loading(comment.id)"
            @click.stop="controller.submit_edit_incident_comment(report, comment)">
            <i class="bi bi-check-lg"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light rounded-circle incident-send-btn"
            :disabled="controller.is_comment_action_loading(comment.id)"
            @click.stop="controller.cancel_edit_incident_comment">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div v-else class="incident-comment-text text-xxs">
          {{ controller.get_incident_comment_display_text(comment, parent_comment) }}
        </div>
      </div>
      <button type="button"
        class="incident-comment-reply btn btn-link text-decoration-none text-xxs fw-bold px-1 pt-1 pb-0"
        @click.stop="controller.start_incident_comment_reply(report, comment)">Reply</button>
      <button v-if="replies.length" type="button"
        class="btn btn-link text-decoration-none text-xxs fw-bold px-1 pt-1 pb-0"
        @click.stop="controller.toggle_incident_replies(report.id, comment.id)">
        {{ replies_are_expanded ? 'Show fewer replies' : 'See more replies' }}
      </button>
    </div>
  </div>

  <div v-if="replies_are_expanded" class="d-flex flex-column gap-3 mt-3">
    <IncidentCommentItem v-for="reply in replies" :key="reply.id" :comment="reply" :parent_comment="comment"
      :report="report" :controller="controller" :depth="depth + 1" />
  </div>
</div>
